const LeaveRemainDayAPI = {
  API_ROOT_URL: '/leaveRemainDay'
};

export default LeaveRemainDayAPI;
